import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import constants from '../../../_consts';

Vue.use(VueAxios, axios);

const mutations = {
  MUTATION_DO_LOGIN: (state, response) => {
    if (response.data.message !== null) {
      state.loginError = true;
      // remove local storage
      localStorage.removeItem(constants.LOCAL_STORE.token);
      localStorage.removeItem(constants.LOCAL_STORE.userId);
      localStorage.removeItem(constants.LOCAL_STORE.role);
      localStorage.removeItem(constants.LOCAL_STORE.userName);
      localStorage.removeItem(constants.LOCAL_STORE.clientId);
      localStorage.removeItem(constants.LOCAL_STORE.clientName);
      localStorage.removeItem(constants.LOCAL_STORE.googleAPIKey);
      localStorage.removeItem(constants.LOCAL_STORE.addOns);
      localStorage.removeItem(constants.LOCAL_STORE.isForceResetPassword);
      state.clientId = null;
    } else {
      // save local storage
      localStorage.setItem(constants.LOCAL_STORE.isForceResetPassword, response.data.forceResetPassword);
      localStorage.setItem(constants.LOCAL_STORE.token, response.data.token);
      localStorage.setItem(constants.LOCAL_STORE.userId, response.data.userId);
      localStorage.setItem(constants.LOCAL_STORE.role, response.data.role);
      localStorage.setItem(constants.LOCAL_STORE.userName, response.data.userName);
      localStorage.setItem(constants.LOCAL_STORE.googleAPIKey, response.data.googleAPIKey);
      localStorage.setItem(constants.LOCAL_STORE.addOns, response.data.addOns);
      localStorage.setItem(constants.LOCAL_STORE.isBingMap, response.data.useBingMap);
      if ([constants.USER_ROLE.accountManager, constants.USER_ROLE.eventManager, constants.USER_ROLE.admin].indexOf(response.data.role) < 0) {
        localStorage.setItem(constants.LOCAL_STORE.clientId, response.data.clientId);
      } else {
        localStorage.setItem(constants.LOCAL_STORE.clientId, 0);
      }

      if ([constants.USER_ROLE.client].indexOf(response.data.role) < 0) {
        localStorage.setItem(constants.LOCAL_STORE.clientName, 'CHOOSE CLIENT');
      } else {
        localStorage.setItem(constants.LOCAL_STORE.clientName, response.data.clientName);
        state.clientName = response.data.clientName;
      }

      // save state
      state.clientId = response.data.role === constants.USER_ROLE.client ? response.data.clientId : 0;
      state.googleAPIKey = response.data.googleAPIKey;
      state.loginError = false;
      state.isCheckedNotification = response.data && response.data.isChecked;
      state.addOns = response.data && response.data.addOns;
    }
  },
  MUTATION_DO_LOGOUT: (state) => {
    // remove all local storage
    let keys = constants.LOCAL_STORE;
    for (const key in keys) {
      if (keys.hasOwnProperty(key)) {
        const element = keys[key];
        localStorage.removeItem(element);
      }
    }
    // localStorage.removeItem(constants.LOCAL_STORE.userId);
    // localStorage.removeItem(constants.LOCAL_STORE.token);
    // localStorage.removeItem(constants.LOCAL_STORE.role);
    // localStorage.removeItem(constants.LOCAL_STORE.googleAPIKey);
    // remove all from state
    state.clientName = '';
    state.loginError = null;
  },
  MUTATION_SET_CLIENTS: (state, clients) => {
    state.clientsList = clients;
  },
  MUTATION_SET_SELECT_CLIENT: (state, itemSelected) => {
    state.selectedClient = itemSelected;
    state.clientId = itemSelected.id;
    state.clientName = itemSelected.clientName;
    localStorage.setItem(constants.LOCAL_STORE.clientId, itemSelected.id);
    localStorage.setItem(constants.LOCAL_STORE.clientName, itemSelected.clientName);
  },
  MUTATION_SET_ERROR: (state, errorObj) => {
    state.isError = errorObj.isError;
    state.errorMessage = errorObj.errorMessage;
  },
  MUTATION_SET_TOKEN_VALID: (state, status) => {
    state.isValidToken = status;
  },
  MUTATION_SET_LOGIN_EMAIL: (state, email) => {
    state.loginEmail = email;
  },
  MUTATION_IS_RESET_PASSWORD_SUCCESS: (state, isResetPasswordSuccess) => {
    state.isResetPasswordSuccess = isResetPasswordSuccess;
  },
  MUTATION_IS_SUBMITTED: (state, isSubmitted) => {
    state.isSubmitted = isSubmitted;
  },
  MUTATION_ALLOW_LOGIN: (state, isAllowed) => {
    state.allowLogin = isAllowed;
  },
  MUTATION_SET_LIST_AM: (state, listAM) => {
    state.listAM = listAM;
  },
  MUTATION_SET_KEYWORD_SEARCH_CLIENTS: (state, keyword) => {
    state.keywordSearchClient = keyword;
  },
  MUTATION_RESET_SEARCH_CLIENTS: state => {
    state.keywordSearchClient = '';
  },
  MUTATION_UPDATE_CLIENT_LIST: (state, client) => {
    state.clientsList.push(client);
  },
  MUTATION_UPDATE_ADDON_CLIENT: (state, updateAddOns) => {
    localStorage.setItem(constants.LOCAL_STORE.addOns, updateAddOns.addOns);
    state.clientsList.forEach((client, index) => {
      if (client.id === updateAddOns.clientId) {
        state.clientsList[index].addOns = updateAddOns.addOns;
      }
    })
  },
  MUTATION_UPDATE_SECONDARY_AM: (state, obj) => {
    state.clientsList.forEach((element, index) => {
      if (element.id === obj.clientId) {
        if (obj.isAdd) {
          state.clientsList[index].secondaryAMList.push(obj.user);
        } else {
          state.clientsList[index].secondaryAMList.forEach((ele, id) => {
            if (ele.id === obj.user.id) {
              state.clientsList[index].secondaryAMList.splice(id, 1);
            }
          })
        }
      }
    })
  },
  MUTATION_UPDATE_RESELLER: (state, obj) => {
    state.clientsList.forEach((element, index) => {
      if (element.id === obj.clientManager) {
        state.clientsList[index].isResellerCheck = obj.isReseller;
      }
    })
  },
  MUTATION_SET_ALL_USER: (state, users) => {
    state.userList = users;
  },
  MUTATION_CREATE_USER: (state, obj) => {
    state.userList.push(obj);
  },
  MUTATION_UPDATE_USER: (state, obj) => {
    state.userList.find((user, index) => {
      if (obj.id === user.id) {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            state.userList[index][key] = obj[key];
          }
        }
      }
    })
  },
  MUTATION_SET_MANAGER_VIEW: (state, view) => {
    state.managerView = view;
  },
  MUTATION_REMOVE_USER_IN_LIST: (state, obj) => {
    let user = state.userList.find(user => user.id === obj.id);
    let index = state.userList.indexOf(user);
    state.userList.splice(index, 1);
  },
  MUTATION_SET_RECENT_CLIENTS: (state, clients) => {
    state.recentClientsList = clients;
  }
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/clients/mutations.js